export default {
  acceptedPaymentMethods: 'Accepted Payment Methods',
  'credit-card': 'Credit Card',
  'gift-card': 'Gift Card',
  paypal: 'Paypal',
  affirm: 'Affirm',
};
